import React, {Component} from "react";
import {
    Alert,
    Linking,
    PermissionsAndroid, Platform, Image, Dimensions,
    ToastAndroid, Share,
    Clipboard,
    I18nManager
} from "react-native";
import NetInfo from "@react-native-community/netinfo";
import AsyncStorage from '@react-native-community/async-storage';

import RNRestart from 'react-native-restart';
import i18n from '../I18n/i18n.js';
import axios from "axios";
import * as shorthash from "shorthash";

import store from "../redux/store";
import {typeExport} from "../redux/store/type";

var persianDigits = "۰۱۲۳۴۵۶۷۸۹";
var persianMap = persianDigits.split("");
import Geolocation from 'react-native-geolocation-service';
import * as geolib from 'geolib';
import {AsyngStorageClass} from "./AsyngStorageClass";
import AndroidOpenSettings from "../importCalss/AndroidOpenSettings";
import {
    serviceActionListNotSendMyApply,
    serviceActionSetLocation,
    serviceActionSetToken,
    serviceActionSetUser,
} from "../screens/137/splash/action/ActionSplashGetAllData";
import {
    serviceActionAddSubList
} from "../screens/137/main/applay/action/ActionListMyApplysScreen";

import {
    serviceActionSetLocation as serviceActionSetLocationSatia,
    serviceActionSetToken as serviceActionSetTokenSatia,
    serviceActionSetUser as serviceActionSetUserSatia,
    serviceActionAccount as serviceActionAccount,
} from "../screens/satia/splash/action/ActionSplashSatiaScreen";
import HMAlert from "../customviews/HMAlert";
import DeviceInfo from "../importCalss/DeviceInfo";
import * as NavigationService from "../redux/NavigationService";


import importFirebase from "../importCalss/firebase/importFirebase";
import Toast from "../customviews/toast";
import Resizer from "react-image-file-resizer";

let firebase = importFirebase;

export class Tools extends Component {
    static check_national_code(value) {

        let c = null, n = null, r = null;
        if (value === '' || value === null || value === undefined)
            return false;

        if (value.length == 10) {
            if (value == '1111111111' || value == '2222222222' || value == '3333333333' || value == '4444444444' || value == '5555555555' || value == '6666666666' || value == '7777777777' || value == '8888888888' || value == '9999999999') {
                return false;
            } else {
                c = parseInt(value.charAt(9));
                n = parseInt(value.charAt(0)) * 10 + parseInt(value.charAt(1)) * 9 + parseInt(value.charAt(2)) * 8 + parseInt(value.charAt(3)) * 7 + parseInt(value.charAt(4)) * 6 + parseInt(value.charAt(5)) * 5 + parseInt(value.charAt(6)) * 4 + parseInt(value.charAt(7)) * 3 + parseInt(value.charAt(8)) * 2;
                r = n - parseInt(n / 11) * 11;
                if ((r == 0 && r == c) || (r == 1 && c == 1) || (r > 1 && c == 11 - r)) {
                    //alert('کد ملی صحیح می باشد');
                    return true;
                } else {
                    return false;
                }
            }
        } else {
            return false;
        }
    }

    static check_Mobile(text) {
        const reg = /^([0]|| [98])?09\d{9}$/;
        if (reg.test(text) === false) {
            return false;
        } else {
            return true;
        }

    }

    static convertToPersianNumber(input) {
        if (input === '' || input === null || input === undefined)
            return "";
        return input.replace(/\d/g, function (m) {
            return persianMap[parseInt(m)];
        });
    }

    static convertToEnglishNumber(input) {
        if (input === '' || input === null || input === undefined)
            return "";
        return input.replace(/[\u06F0-\u06F90]/g, function (m) {
            return persianDigits.indexOf(m);
        });
    }

    static convertToEnglishNumberWord(text) {
        return text.replace(/[٠-٩۰-۹]/g, a => a.charCodeAt(0) & 15);
    }

    static GetTimeMap(location, myLocation, Coefficient) {
        var input = null
        if (Coefficient)
            input = Tools.getDistance(location, myLocation) * Coefficient
        else
            input = Tools.getDistance(location, myLocation)

        //let input = Tools.getDistance(location, myLocation)
        if (input === '' || input === null || input === undefined)
            return "0";
        if (input < 60) {
            return input.toFixed() + " ثانیه ";
        } else if (input < 3600) {
            return (input / 60).toFixed() + " دقیقه ";
        } else if (input < 86400) {
            return (new Date(input * 1000)).toUTCString().match(/(\d\d:\d\d:\d\d)/)[0];

        } else {
            return "زمان زیاد";
        }

    }

    static getDistance(location, myLocation) {


        return geolib.getDistance({
            latitude: myLocation.latitude ? myLocation.latitude : myLocation.lat,
            longitude: myLocation.longitude ? myLocation.longitude : myLocation.lng
        }, {
            latitude: parseFloat(location.latitude ? location.latitude : location.lat),
            longitude: parseFloat(location.longitude ? location.longitude : location.lng)
        })
    }

    static GetDistanceMap(location, myLocation) {
        let input = Tools.getDistance(location, myLocation)

        if (input === '' || input === null || input === undefined)
            return "0";
        if (input < 1000) {
            return input.toFixed() + " متر ";
        } else {
            return (input / 1000).toFixed(1) + " کیلومتر ";
        }


    }

    static consoleCustumize(name, value) {
    }


    static numberWithCommas(x) {
        if (x === null || x === "null" || x === '' || x === undefined)
            return '';

        x = x.toString().replace(/,/g, '');
        x = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return x;

        //return x;
    }// numberWithCommas()


    static GetAllCountCart(x) {
        if (x === null || x === "null" || x === '' || x === undefined || x === [])
            return 0;

        let count = 0;
        x.map((item, key) => {
            count = count + item.count_cart
        })

        return count;

        //return x;
    }// numberWithCommas()

    static PriceAllWithDiscountALL(PriceAll, DiscountAll, discount) {
        if (PriceAll === null || PriceAll === "null" || PriceAll === '' || PriceAll === undefined || PriceAll === [])
            return 0;


        return (PriceAll - DiscountAll) * (discount / 100);

        //return x;
    }// numberWithCommas()


    // static round(value, step) {
    //     step || (step = 1.0);
    //     var inv = 1.0 / step;
    //     return Math.round(value * inv) / inv;
    // }

    // static round(number) {
    //     var value = (number * 2).toFixed() / 2;
    //     return value;
    // }

    // static round(num) {
    //     return Math.round(num*2)/2;
    // }

    static round(x) {
        let data = parseInt(x);
        let d = x - data;
        let res = 0;
        if (d === 0) {
            res = x;
        } else if (d === .5) {
            res = x;
        } else {
            res = data + .5;
        }
        return res
    }

    static GoLink_AI(link_ios, link_android) {
        return Linking.openURL(Platform.OS === "ios" ? link_ios : link_android).catch(err => console.error('An error occurred', err))
    }

    static GoLinking(link) {
        return Linking.openURL(link).catch(err => console.error('An error occurred', err))
    }

    static CallNumber(text) {
        const url = Platform.OS === 'ios' ? `telprompt:${text}` : `tel://${text}`;
        Linking.canOpenURL(url)
            .then((supported) => {
                if (supported) {
                    return Linking.openURL(url).catch(() => null);
                }
            });


    }

    static getValue(text) {
        return text ? (text.name ? text.name : (text.value ? text.value : text.title ? text.title : text)) : null
    }

    // static CheckValue(data) {
    //     return data ? data.id : null
    // }

    static async remove() {
        try {
            //await AsyncStorage.removeItem(IDCITY);
            await AsyncStorage.removeItem(typeExport._USER);
            await AsyncStorage.removeItem(typeExport.TOKEN);
            await AsyncStorage.removeItem(typeExport._ACCOUNT);
            store.dispatch(serviceActionSetTokenSatia(null));
            store.dispatch(serviceActionAccount(null));
            store.dispatch(serviceActionSetUserSatia(null));

        } catch (error) {
            alert(i18n.t('constant.retry'))
        }
    }

/*    static exitApp() {
        HMAlert(
            i18n.t('constant.message'),
            i18n.t('constant.WantToLogOut'),
            [
                // {text: 'Ask me later', onPress: () => {}},
                {
                    text: i18n.t('constant.No'), onPress: () => {
                    }, style: 'cancel'
                },
                {
                    text: i18n.t('constant.Yes'), onPress: () => {
                        Tools.remove()
                        //, NavigationService.resetTo('SplashScreen')
                    }
                },
            ],
            {cancelable: true}
        )

    }*/


    static ErrorMessage(data) {
        let message = "";
        try {
            if (data && data.length > 0) {
                data.map(function (data, index) {
                    message += data + '\n'
                });
                return message
            } else
                return data
        } catch (e) {
            return data
        }


    }

    static Calculateـtheـfinalـamount(first_buy_discount, PriceAll, DiscountAll) {
        return first_buy_discount !== null ? ((PriceAll) - (parseInt((PriceAll - parseInt(DiscountAll)) * (first_buy_discount.percent / 100)) + parseInt(DiscountAll))) : PriceAll - parseInt(DiscountAll)
    }

    static Calculate_ـDiscount_the_first_purchase(first_buy_discount, PriceAll, DiscountAll) {
        return (first_buy_discount !== null ? parseInt((PriceAll - parseInt(DiscountAll)) * (first_buy_discount.percent / 100)) : 0)
    }


    static validateEmail(email) {
        const expression = /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;

        return expression.test(String(email).toLowerCase())
    }

    /////////////////////////////////////////////////////////
    static scrollIntoViewNonInput(ref, message, onPress, context) {
        context._scrollIntoView("ref_" + ref)
        HMAlert(
            i18n.t('constant.message'),
            message,
            [
                // {text: 'Ask me later', onPress: () => {}},
                // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                {text: i18n.t('constant.ok'), onPress: () => onPress},
            ],
            {cancelable: true}
        )
    }


    static async changeAppLang(lang, type) {
        //i18n.locale = 'fa';
        if (lang != 'en') {
            if (!I18nManager.isRTL) {
                await I18nManager.forceRTL(true);
            }
        } else {
            if (I18nManager.isRTL) {
                await I18nManager.forceRTL(false);
            }
        }
        await AsyngStorageClass.setLang(lang);


        if (Platform.OS !== "web")

            RNRestart.Restart()
        else {
            await I18nManager.forceRTL(lang == 'fa');

            window.location.reload();
        }
    }

    static async ConvertStringLanguages(lang) {


        if (!I18nManager.isRTL) {

        } else {

        }


        // RNRestart.Restart()
    }


    static CheckNetWork(data) {
        if (Platform.OS === "android") {
            NetInfo.isConnected.fetch().then(isConnected => {
                if (isConnected) {
                    HMAlert("You are online!");
                } else {
                    HMAlert("You are offline!");
                }
            });
        } else {
            // For iOS devices
            NetInfo.isConnected.addEventListener(
                "connectionChange",
                Tools.handleFirstConnectivityChange
            );
        }
        // NetInfo.isConnected.addEventListener(
        //     'connectionChange',
        //     Tools._handleConnectivityChange
        // );
        //
        // NetInfo.isConnected.fetch().done((isConnected) => {
        //
        //     // if(isConnected == true)
        //     // {
        //     //     //this.setState({connection_Status : "Online"})
        //     // }
        //     // else
        //     // {
        //     //   //  this.setState({connection_Status : "Offline"})
        //     // }
        //     return isConnected
        // });
    }

    static handleFirstConnectivityChange = isConnected => {
        const min = 1;
        const max = 100;
        const rand = min + Math.random() * (max - min);
        // return isConnected
        // NetInfo.isConnected.removeEventListener(
        //     "connectionChange",
        //     Tools.handleFirstConnectivityChange
        // );

        // if (isConnected === false) {
        //     HMAlert("You are offline!");
        // } else {
        //     HMAlert("You are online!");
        // }
    };

    static GoLinkUpdate(link_ios, link_android) {
        return Linking.openURL(Platform.OS === "ios" ? link_ios : link_android).catch(err => console.error('An error occurred', err))
    }

    static GoLink(url, type) {
        if (type === 'phone') {
            url = Platform.OS === 'ios' ? `telprompt:${url}` : `tel://${url}`;
            Linking.canOpenURL(url)
                .then((supported) => {
                    if (supported) {
                        return Linking.openURL(url)
                            .catch(() => null);
                    }
                });
        }

        // return Linking.openURL(url).catch(err => console.error('An error occurred', err))
        else {
            if (Platform.OS == 'web') {
                // return window.open(url, '_blank');
                // return        window.location.assign(url);
                //  return        window.history.replaceState( {} , "hi", url );
                //  return <Redirect to={url}>Go to Jane's profile</Redirect>;

                if (type === 'self')
                    return window.location.href = url;
                else
                    return window.open(url, '_blank');
                // return      window.location = url;
                //return     window.navigate("https://www.google.com/");

                // return         window.open(url,'_self');


                //  var importantStuff = window.open(url, '_blank');
                //  importantStuff.document.write('لطفا صبر نمایید ...');
                //  importantStuff.location.href = url;
                //importantStuff.close();


            } else {
                return Linking.openURL(url).catch(err => console.error('An error occurred', err))
            }
        }
    }

    static GoLinkMap(lat, lng) {
        // const scheme = Platform.select({ ios: 'maps:0,0?q=', android: 'geo:0,0?q=' });
        // const latLng = `${lat},${lng}`;
        // const label = 'Custom Label';
        // const urll = Platform.select({
        //     ios: `${scheme}${label}@${latLng}`,
        //     android: `${scheme}${latLng}(${label})`
        // });
        //
        //
        // Linking.openURL(urll);


        const location = `${lat},${lng}`
        const url = Platform.select({
            ios: `maps:${location}`,
            //  android: `geo:${location}?center=${location}&q=${location}&z=16`,
            android: `geo:${location}`,
            web: `geo:${location}`,
        });
        Linking.openURL(url);
    }


    static _RemoveConnectivity(isConnected) {

        NetInfo.isConnected.removeEventListener(
            'connectionChange',
            Tools.handleFirstConnectivityChange
        );
    };

    // static DownloadFile(image,onPress) {
    //
    //     const uri = baseUrlImage + image;
    //     const name = shorthash.unique(uri);
    //     const extension = (Platform.OS === 'android') ? 'file://' : ''
    //     const path = `${extension}${RNFS.CachesDirectoryPath}/${name}.jpg`;
    //
    //     RNFS.exists(path).then(exists => {
    //         if (exists) this.loadFile
    //         else this.downloadFile(uri, path);
    //     }).then(a => {
    //
    //
    //     }).catch(e => {
    //         HMAlert(i18n.t('constant.message'), Tools.ErrorMessage(propss.resultsSet.message), [
    //                 // {text: 'Ask me later', onPress: () => {}},
    //                 // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
    //                 {text: i18n.t('constant.ok'), onPress: () => {}},
    //             ],
    //             {cancelable: false}
    //         )
    //     })
    // };

    static errorDownlod(onPress) {
        /*   if(onPress)
           HMAlert(i18n.t('constant.message'), i18n.t('constant.retry'), [
                   // {text: 'Ask me later', onPress: () => {}},
                   // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                   {
                       text: i18n.t('constant.ok'), onPress: () => {
                           onPress
                       }
                   },
               ],
               {cancelable: false}
           )*/
    }

    static BackgroundImageeeeee(image) {
        var images = [],
            imgWidth = 7,
            winWidth = Dimensions.get('window').width;

        for (var i = 0; i < Math.ceil(winWidth / imgWidth); i++) {
            images.push((
                <Image
                    // source={{uri: image}}
                    // source={this.state.source === null ? require("../assets/img/backgrounad22.png") : {uri: this.state.source}}
                    //  source={(image && image != null) ? require(PathFile.image.background) : {uri: image}}
                    //  source={(image && image != null) ? PathFile.image.background : image}
                    // source={require("../assets/img/heart.png")}
                    //  {this.props.DataSplashScreen.Background && this.props.DataSplashScreen.Background == null ? {uri: this.props.DataSplashScreen.Background} : PathFile.image.background}
                    style={{backgroundColor: '#ee1a46',}}

                />
            ))
        }
        return images
    }

    static BackgroundImage(image) {
        if (image && image != null)
            return image
        // return require(`${image}`)
        //   return require(image)
        else
            return null


    }

    static async RequestSubmit(typeConnection, url, params, type, func) {

        // let {ListNotSendMyApply} = store.getState().reducerSplashGetAllData;
        let ListNotSendMyApply = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListMyApplyOffline + type);
        let ListMyApply = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListMyApply + type)
        let index = 0;


        if (ListNotSendMyApply && ListNotSendMyApply != null && ListNotSendMyApply.length > 0) {
            params = ListNotSendMyApply[0];


            //  let mobile = store.getState().reducerSplashGetAllData.user.mobile;

            let DateTime = new Date().getTime()

            let nameImage = DateTime + '.jpg';
            let nameVideo = DateTime + '.mp4';
            let nameAudio = DateTime + '.aac';

            //  let nameImage = timeee + params.token + ".jpg";
            // let nameVideo = timeee + params.token + ".mp4";
            /// let nameImage = "0123456789012345678901234567890123456789" + ".jpg";
            // let nameVideo = "0123456789012345678901234567890123456789"  + ".mp4";
            const formData = new FormData();
            formData.append('_operation', typeExport._Contacts);
            // // formData.append('lang', params.lang);
            formData.append('mode', "SaveTickets");
            formData.append('lang', params.lang);
            //  formData.append('token', params.token);
            formData.append('type', params.type);
            formData.append('subject', params.subject);
            formData.append('subjectid', params.subjectid);
            formData.append('category', params.category);
            formData.append(params.typeComponent ? '_session' : 'token', params.token);
            formData.append('type', params.type);
            formData.append('typepm', params.typepm);
            /*          //formData.append('image', params.image);
                      if (params.image !== null) formData.append('image', {
                          uri: params.image,
                          name: nameImage,
                          type: 'image/jpeg'
                      });
                      if (params.video !== null) formData.append('video', {
                          uri: params.video,
                          name: nameVideo,
                          type: 'video/mp4'
                      });*/


            if (params.audio && params.audio !== null) {
                formData.append('durationVoice', params.durationVoice);

                if (Platform.OS === "web") {
                    //  formData.append('audio', params.audio, nameAudio + ".aac");
                    formData.append('audio', params.audioBlob, nameAudio);
                    //const blobFile = new File([params.audio], nameAudio + ".aac");
                    //formData.append("audio", params.audioBlob);
                }
                else
                    formData.append('audio', {
                        uri: params.audio,
                        name: nameAudio,
                        type: 'audio/aac'
                    });
            }

            // if (params.image && params.image !== null)
            //     if (Platform.OS === "web") {
            //         formData.append('image', params.image, nameImage );
            //
            //     }
            //     else
            //         formData.append('image', {
            //             uri: params.image,
            //             name: nameImage,
            //             type: 'image/jpeg'
            //         });
            if (params.video && params.video !== null) {
                if (Platform.OS === "web") {
                    //  formData.append('audio', params.audio, nameAudio + ".aac");
                    formData.append('video', params.video, nameVideo);
                    //const blobFile = new File([params.audio], nameAudio + ".aac");
                    //formData.append("audio", params.audioBlob);
                }
                else
                    formData.append('video', {
                        uri: params.video,
                        name: nameVideo,
                        type: 'video/mp4'
                    });
            }
            /*    if (params.video && params.video !== null) formData.append('video', {
                    uri: params.video,
                    name: nameVideo,
                    type: 'video/mp4'
                });*/
            for (let i = 0; i < params.arrImage.length; i++) {


                if (Platform.OS === "web") {
                    formData.append('image' + "_" + i, params.arrImage[i], `${i}_${nameImage}`);
                }
                else

                    formData.append('image' + "_" + i, {
                        uri: params.arrImage[i],
                        name: nameImage,
                        type: 'image/jpeg'
                    });
            }


            formData.append('description', params.description);
            formData.append('address', params.address);
            formData.append('longitude', params.longitude);
            formData.append('latitude', params.latitude);
            formData.append('private', params.private);
            formData.append('offline', true);
            formData.append('platform', Platform.OS);
            // formData.append('token_fb', params.token_fb);
            /*    formData.append('_operation',"loginContact");
                formData.append('username', "09186005330");
                formData.append('password', 123456);*/

            const config = {
                headers: {
                    "Content-Type": "multipart/form-data; charset=utf-8;",
                    // 'Content-Type': 'application/json',
                    "Authorization": `Basic ${params.token}`,
                    timeout: typeExport._TIMEOUT,
                }
            };
            /*    axios(
                    {
                        url: baseUrl + url + params,
                        method: typeConnection,
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        },
                        /!*      headers: {'X-Requested-With': 'XMLHttpRequest'},*!/
                    }
                )*/


            axios.post(url, formData, config)
                .then(async response => {
                    let data = response.data;

                    if (response.data.success === true) {
                        ListNotSendMyApply.splice(index, 1);
                        await AsyngStorageClass.setAsyng(global.IdCity + typeExport.ListMyApplyOffline + type, ListNotSendMyApply);
                        /////////////////////////////////////////////////////////////////////////
                        let obj = {
                            address: params.address,
                            code: "_",
                            color: "#ff0000",
                            comment: [],
                            createdtime: params.date,
                            image: params.image,
                            video: params.video,
                            /*    files: [
                                    {
                                        file: params.image,
                                        type: "image/jpeg"
                                    },
                                    {
                                        file: params.video,
                                        type: "video/mp4"
                                    },
                                ],*/
                            latitude: params.latitude,
                            longitude: params.longitude,
                            status: i18n.t('constant.registrated'),
                            title: params.subject,
                            subjectid: params.subjectid,

                        };
                        await AsyngStorageClass.setAsyng(global.IdCity + typeExport.ListMyApply + params.type, [obj, ...ListMyApply])

                        store.dispatch(serviceActionAddSubList([obj, ...store.getState().reducerListMyApplyScreen.results]));

                        /////////////////////////////////////////////////////////////////////////

                        store.dispatch(serviceActionListNotSendMyApply(ListNotSendMyApply));

                        Tools.RequestSubmit(typeConnection, url, params, type)

                    } else {
                        //   NavigationService.navigatereset('LoginStack');

                    }
                    func ? func() : null;
                }).catch((e) => {
                func ? func() : null;

                console.log(e)
            })
        }
        else {
            func ? func() : null;
        }

    }

    static SaveJson(nameJson, String) {


        const name = shorthash.unique(nameJson);
        const extension = (Platform.OS === 'android') ? 'file://' : ''
        const path = `${extension}${RNFS.CachesDirectoryPath}/${name}.txt`;
        RNFS.writeFile(path, String, 'utf8')
            .then((success) => {
            })
            .catch((err) => {
            });
        // /*   RNFS.exists(path).then(exists => {
        //        if (exists) Tools.CallLoadFile(uri, uriBackGround, path, type, callServiceBackground);
        //        else Tools.CallDownloadFile(uri, uriBackGround, path, type, callServiceBackground);
        //    }).catch(e => {
        //        // Tools.errorDownlod(this.getAsyncStorage())
        //    })*/
    }

    static GetJson(nameJson) {

        const name = shorthash.unique(nameJson);
        const extension = (Platform.OS === 'android') ? 'file://' : ''
        const path = `${extension}${RNFS.CachesDirectoryPath}/${name}.txt`;

        let text = null
        RNFS.exists(path).then(async exists => {
            if (exists) {
                text = await RNFS.readFile(path).then(res => {
                })
            } else {
            }
        }).catch(e => {
            // Tools.errorDownlod(this.getAsyncStorage())
        })

        /*    RNFS.readDir(RNFS.MainBundlePath) // On Android, use "RNFS.DocumentDirectoryPath" (MainBundlePath is not defined)
                .then((result) => {

                    // stat the first file
                    return Promise.all([RNFS.stat(result[0].path), result[0].path]);
                })
                .then((statResult) => {
                    if (statResult[0].isFile()) {
                        // if we have a file, read it
                        return RNFS.readFile(statResult[1], 'utf8');
                    }

                    return 'no file';
                })
                .then((contents) => {
                    // log the file contents
                })
                .catch((err) => {
                });*/
    }


    static async SaveTokenUserAsyncProps(token, user) {

        if (token) {
            await AsyngStorageClass.setToken(token)
            store.dispatch(serviceActionSetToken(token))
        }

        if (user) {
            //   await AsyngStorageClass.setToken(data)
            store.dispatch(serviceActionSetUser(user))
        }


    }

    static async getSizeFile(data) {

        let bytes = await stat(data);

        bytes = bytes.size;

        /*        if (bytes < 1024) return bytes;
                else if (bytes < 1048576) return (bytes / 1024).toFixed(3);
                else if (bytes < 1073741824) return (bytes / 1048576).toFixed(2);
                else return (bytes / 1073741824).toFixed(3);*/


    }


    static getSizeByte(bytes, flag) {

        bytes = bytes.size;
        if (flag) {
            if (bytes < 1024) return (bytes + " Bytes");
            else if (bytes < 1048576) return (bytes / 1024).toFixed(0) + " KB";
            else if (bytes < 1073741824) return (bytes / 1048576).toFixed(0) + " MB";
            else return (bytes / 1073741824).toFixed(0) + " GB";
        }
        else {

        }


    }

    static getSizeMG(data, type, myService) {

        let FupToInternet = myService && myService.FupToInternet ? myService.FupToInternet : 4
        data = data / FupToInternet;
        if (type) {
            if (data >= 1024) return (((data / 1024)).toFixed(2) + " GB");
            else return (data).toFixed(2) + " MB";
        }
        //  ((data / (FupToInternet * 1024)) * 100) / 100
        let d = (data / 1024);
        //return (((data / 1024)).toFixed((!isNaN(d) && d.toString().indexOf('.') != -1) ? 2 : 0) + "");
        return ((d).toFixed(Tools.getToFixed(d)) + "");

        // return ((((data / 1024) * 100) / 100) + "");
        //   return data + " GB";


    }

    static getToFixed(n) {
        if (n.toFixed(0) <= 0) {
            if (n.toFixed(2) == 0.00)
                return 0
            else
                return 2
        }
        else {
            return 2

        }
        //      return Number(n) === n && n % 1 !== 0;
    }

    static convertByte(bytes, flag, type) {
        // bytes= Math.round(bytes * 100) / 100
        if (type) {
            let d = (bytes / 1073741824);
            return (bytes / 1073741824).toFixed(Tools.getToFixed(d));

        }
        if (flag) {
            if (bytes < 1024) return (bytes.toFixed(2) + " B");
            else if (bytes < 1048576) return (bytes / 1024).toFixed(2) + " KB";
            else if (bytes < 1073741824) return (bytes / 1048576).toFixed(2) + " MB";
            else return (bytes / 1073741824).toFixed(2) + " GB";
        }
        else {

        }


    }

    static M_convertOnlyGig(data, myService) {
        let FupToInternet = myService && myService.FupToInternet ? myService.FupToInternet : 4

        // bytes= Math.round(bytes * 100) / 100
        //  return (bytes / 1073741824);
        return ((data / (FupToInternet * 1024)) * 100) / 100;
    }

    static convertOnlyGig(bytes) {
        // bytes= Math.round(bytes * 100) / 100
        //  return (bytes / 1073741824);
        return ((bytes / 1073741824) * 100) / 100;
    }

    static CheckRoutes(routes, item) {
        let CH = routes.find((element) => {
            return element.routeName === item
        })
        return (CH)
    }

    static CheckValue(text, type) {
        // if (type && text && text.length > 0)
        //     text = text.trim()

        if (!text || text === null || text === "null" || text === undefined || text === "undefined" || text === "" || text === " " || text.length === 0)
            return null
        else
            return text.id ? (text.id != '0' ? text.id : null) : Tools.CheckNull(text)
        //  return text
    }

    // static CheckValue(text) {
    //
    //     if(text==0)
    //         return text
    //
    //     if (!text || text === null || text === "null" || text === undefined || text === "undefined" || text === "" || text === " " || text.length === 0)
    //         return null
    //     else
    //         return text.id ? text.id : text
    //     //  return text
    // }

    static CheckNull(text) {
        return text.name === null ? text.name : (text.value === null ? text.value : text.title === null ? text.title : text)
    }

    static async checkPermission(type, item, key, goScreen, stateError, Parent) {
        let {Location} = store.getState().reducerSplashGetAllData

        if (Location != null) {
            goScreen(type, item, Location);
        } else {
            let granted = false
            //  NavigationService.navigateParams("ShowMap", {item})


            if (Platform.OS === 'android') {
                granted = await PermissionsAndroid.request(
                    PermissionsAndroid.PERMISSIONS.ACCESS_FINE_LOCATION,
                    /*  {
                          title: 'Give Location Permission',
                          message: 'App needs location permission to find your position.'
                      }*/
                )

                /*
                   switch (granted.android.permission.ACCESS_FINE_LOCATION) {
                       case "granted":

                           Tools.getCurrentPosition(type, item, key, goScreen, stateError)

                           break;

                       case "denied":

                           stateError();
                           break;

                       case "blocked":

                           stateError();
                           break;
                       default:


                   }*/
                if (granted === PermissionsAndroid.RESULTS.GRANTED) {

                    /*    this.setState({}
                            , () => {
                            }
                        )*/
                    Tools.getCurrentPosition(type, item, key, goScreen, stateError, Parent)
                } else {
                    stateError();
                }
            } else {
                Tools.getCurrentPosition(type, item, key, goScreen, stateError, Parent)
            }

        }


    }

    static async hasLocationPermission() {
        if (Platform.OS === 'ios' ||
            (Platform.OS === 'android' && Platform.Version < 23)) {
            return true;
        }

        const hasPermission = await PermissionsAndroid.check(
            PermissionsAndroid.PERMISSIONS.ACCESS_FINE_LOCATION
        );

        if (hasPermission) return true;

        const status = await PermissionsAndroid.request(
            PermissionsAndroid.PERMISSIONS.ACCESS_FINE_LOCATION
        );

        if (status === PermissionsAndroid.RESULTS.GRANTED) return true;

        if (status === PermissionsAndroid.RESULTS.DENIED) {
            ToastAndroid.show('Location permission denied by user.', ToastAndroid.LONG);
        } else if (status === PermissionsAndroid.RESULTS.NEVER_ASK_AGAIN) {
            ToastAndroid.show('Location permission revoked by user.', ToastAndroid.LONG);
        }

        return false;
    }

    static async getCurrentPosition222(type, item, key, goScreen, stateError, Parent) {
        const hasLocationPermission = await Tools.hasLocationPermission();

        if (!hasLocationPermission) return;

        this.setState({loading: true}, () => {
            Geolocation.getCurrentPosition(
                (position) => {

                    //do stuff with location
                    //  this.setState({isLoading: false, index: -1})
                    //stateSuccess();
                    store.dispatch(serviceActionSetLocation(position))
                    goScreen(type, item, position);
                    //  NavigationService.navigateParams(type, {item: item})

                },
                (error) => {
                    if (Parent) {

                    } else {
                        if (error.code == 2 && Platform.OS === 'android')
                            AndroidOpenSettings.locationSourceSettings()
                        else {
                            if (key == 'retry') {
                                HMAlert(i18n.t('constant.message'), "برای دقت بیشتر و همچنین برای پیدا نمودن مکان شما زیر سقف نباشید", [
                                        {
                                            text: i18n.t('constant.ok'), onPress: () => {
                                            }
                                        },
                                    ],
                                    {cancelable: true}
                                )
                            }
                            else {
                                let {latitude, longitude} = store.getState().reducerSplashGetAllData.resultsSaina.result.info
                                let center = typeExport._NameApp == "CloudTest" || typeExport._NameApp == "Cloud" ? store.getState().reducerSplashGetAllData?.City?.map?.center : null;
                                goScreen(type, item, {

                                    coords: {
                                        latitude: center ? parseFloat(center.latitude) : parseFloat(latitude),
                                        longitude: center ? parseFloat(center.longitude) : parseFloat(longitude),
                                    }
                                });
                            }


                        }

                        stateError();
                        /* this.setState({
                             locationEnabled: false,
                             isLoading: false,
                             index: -1
                         }, () => {

                         })*/
                    }

                },
                {
                    enableHighAccuracy: true,
                    timeout: 15000,
                    maximumAge: 10000,
                    distanceFilter: 50,
                    forceRequestLocation: true
                }
            );
        });
    }


    static getCurrentPosition(type, item, key, goScreen, stateError, Parent) {

        Geolocation.getCurrentPosition(
            async (position) => {
                // position={
                //
                //     coords: {
                //         latitude: parseFloat(latitude),
                //         longitude: parseFloat(longitude),
                //     }
                // };

                //do stuff with location
                //  this.setState({isLoading: false, index: -1})
                //stateSuccess();
                store.dispatch(serviceActionSetLocation(position))
                goScreen(type, item, position);
                //  NavigationService.navigateParams(type, {item: item})

            },
            (error) => {
                console.log("error", error)
                if (Parent) {
                    stateError();
                } else {
                    stateError();

                    if (error.code == 2 && Platform.OS === 'android')
                        AndroidOpenSettings.locationSourceSettings()
                    else {

                        if (key == 'retry') {
                            HMAlert(i18n.t('constant.message'), "برای دقت بیشتر و همچنین برای پیدا نمودن مکان شما زیر سقف نباشید", [
                                    {
                                        text: i18n.t('constant.ok'), onPress: () => {
                                        }
                                    },
                                ],
                                {cancelable: true}
                            )
                        }
                        else {

                            let {latitude, longitude} = typeExport._TypeApp == "Satia" ? {
                                latitude: "34.084652",
                                longitude: "49.688403"
                            } : store.getState().reducerSplashGetAllData.resultsSaina ? store.getState().reducerSplashGetAllData.resultsSaina.result.info : store.getState().reducerSplashGetAllData.resultsShahrdar.result.info

                            goScreen(type, item, {

                                coords: {
                                    latitude: parseFloat(latitude),
                                    longitude: parseFloat(longitude),
                                }
                            });
                        }


                    }

                    /* this.setState({
                         locationEnabled: false,
                         isLoading: false,
                         index: -1
                     }, () => {

                     })*/
                }

            },
            {enableHighAccuracy: false, timeout: 20000, maximumAge: 0}
        );
    }

    static persianToEnglish(value) {
        //value = parseInt(value)
        var newValue = "";
        if (value)
            for (var i = 0; i < value.length; i++) {
                var ch = value.charCodeAt(i);
                if (ch >= 1776 && ch <= 1785) // For Persian digits.
                {
                    var newChar = ch - 1728;
                    newValue = newValue + String.fromCharCode(newChar);
                } else if (ch >= 1632 && ch <= 1641) // For Arabic & Unix digits.
                {
                    var newChar = ch - 1584;
                    newValue = newValue + String.fromCharCode(newChar);
                } else
                    newValue = newValue + String.fromCharCode(ch);
            }
        return newValue;
    }


    static getAudioTimeString(seconds) {
        const h = parseInt(seconds / (60 * 60));
        const m = parseInt(seconds % (60 * 60) / 60);
        const s = parseInt(seconds % 60);

        return ((h < 10 ? '0' + h : h) + ':' + (m < 10 ? '0' + m : m) + ':' + (s < 10 ? '0' + s : s));
    }

    static getAudioTimeStringMin(seconds) {
        //  const h = parseInt(seconds / (60 * 60));
        const m = parseInt(seconds % (60 * 60) / 60);
        const s = parseInt(seconds % 60);

        return ((m < 10 ? '0' + m : m) + ':' + (s < 10 ? '0' + s : s));
    }

    static getTimeStringM(seconds) {
        const m = parseInt(seconds % (60 * 60) / 60);
        const s = parseInt(seconds % 60);

        return ((m < 10 ? '0' + m : m) + ':' + (s < 10 ? '0' + s : s));
    }

    static onShare(item) {
        let data = null;
        //if (typeExport._NameApp === "Satia")
        data = store.getState().reducerSplashSatiaScreen && store.getState().reducerSplashSatiaScreen.results && store.getState().reducerSplashSatiaScreen.results.info;
        // else
        //     data = store.getState().reducerSplashGetAllData.resultsSaina.result.info;


        let url = item && item.link_url ? item.link_url : (Platform.OS === "ios" ? data.ios.link : data.android.link);
        let message = item && item.description ? item.description + "\n" + (item.link_url ? item.link_url : "") : (Platform.OS === "ios" ? data.description + "\n" + data.ios.link : data.description + "\n" + data.android.link);

        if (Platform.OS === "web") {
            if (navigator.share) {
                navigator.share({
                    title: 'web.dev',
                    text: message,
                    url: url,
                })
                    .then(() => console.log('Successful share'))
                    .catch((error) => console.log('Error sharing', error));
            }
            else {
                Tools.copyClipboardWeb(url)
                // navigator.clipboard.writeText(url)
                // Toast.show({
                //     // type: 'success | error | info',
                //     type: 'custom_info',
                //     //  type: data.status ? 'custom_success' : 'custom_error',
                //     //  position: 'top | bottom',
                //     position: 'top',
                //     text1: i18n.t('constant.message'),
                //     text2: "لینک کپی شد",
                //     visibilityTime: 4000,
                //     autoHide: true,
                //     //  topOffset: 30,
                //     // bottomOffset: 40,
                //     onShow: () => {
                //     },
                //     onHide: () => {
                //     }
                // })
            }

        }


        else {
            // console.log("Share was ", message, url)
            Share
                .share(
                    {
                        message: message,
                        url: url,
                    }
                )

                .then(
                    ({action, activityType}) => {
                        if (action === Share.sharedAction)
                            console.log('Share was successful');
                        else
                            console.log('Share was dismissed');
                    }
                )
            ;
        }


    }

    static DeviceInfo(formData) {
        // let DeviceInfo = null;
        // if (Platform.OS != "web")
        //     DeviceInfo = require("react-native-device-info")
        formData.append('lang', i18n.locale);
        formData.append('platform', Platform.OS);
        formData.append('token_fb', store.getState().reducerSplashSatiaScreen.token_fb);
        formData.append('platform', Platform.OS);
        formData.append('userAgentData', Platform.OS === "web" ? navigator.userAgentData?.mobile : false);
        // formData.append('userAgentData', true);

        if (formData && Platform.OS !== "web") {
            /*            let getUniqueId = DeviceInfo.getUniqueId();

                        if (Clipboard)
                            Clipboard.setString(getUniqueId)*/

            formData.append('BuildNumber', Platform.OS === 'ios' ? DeviceInfo.getBuildNumber() : DeviceInfo.getVersion());

            formData.append('UniqueId', DeviceInfo.getUniqueId());
        }
    }

    static SubString(text, count) {
        return text.length > count ?
            text.substring(0, count) + "..."
            : text

    }

    static receiveOnNotificationOpened() {
        if (Platform.OS !== "web" && firebase) {
            return firebase.notifications().onNotificationOpened((notificationOpen: NotificationOpen) => {
                // Get the action triggered by the notification being opened
                const action = notificationOpen.action;
                // Get information about the notification that was opened
                const notification: Notification = notificationOpen.notification;
                let item = null
                if (notificationOpen.notification.data.item)
                    item = JSON.parse(notificationOpen.notification.data.item.replace(new RegExp('}"', "g"), "}").replace(new RegExp('"{', "g"), "{").trim())

                // console.log("NotificationOpen", notificationOpen.notification.data.item, item)
                try {
                    firebase.notifications().removeDeliveredNotification(notificationOpen.notification._notificationId)

                    switch (notificationOpen.notification.data.typeOperation) {

                        case "1":

                            NavigationService.navigateParams("DetailsOperatorApplyScreen", {
                                index: 0,
                                item: item,
                            })
                            break;

                        //looking for
                        case "2":
                            if (item) {
                                func ? func(item) : null
                                /*   if (this.props.result && this.props.result > 0) {
                                       let idx = this.props.result.CartList.findIndex(obj => obj.RequestID === item.RequestID)
                                       if (idx === -1) {
                                           store.dispatch(serviceActionListFilter([]))
                                           this.props.callserviceActionRefresh();
                                           this.getData(1)
                                       }

                                   }

                                   NavigationService.navigateParams("DetailsOperatorFireApplyScreen", {
                                       index: 0,
                                       item: item,
                                   })*/
                            }

                            // console.log("notificationOpen1", notificationOpen.notification.data.type)
                            // NavigationService.navigatereset("MessagesBuy", {type: 1});
                            //NavigationService.navigateParams("MessagesBuy", {type: 2});
                            break;

                        // case "1":
                        //     //  console.log("notificationOpen2", notificationOpen.notification.data.type)
                        //     // NavigationService.navigatereset("MessagesSell", {type: 2});
                        //     NavigationService.navigateParams("MessagesSell", {type: 1});
                        //     break;
                        default:
                        // console.log("notificationOpen", notificationOpen.notification.data.type)

                    }

                }
                catch (e) {

                }
                /*   console.log("notificationOpen", notificationOpen)
                   console.log("notificationOpen.action", notificationOpen.action)
                   console.log("notificationOpen.notification", notificationOpen.notification)*/

            });
        }
    }

    static receiveonOnNotification(func) {
        if (Platform.OS !== "web" && firebase) {
            const channel = new firebase.notifications.Android.Channel(
                'channelId',
                'Channel Name',
                firebase.notifications.Android.Importance.Max
            ).setDescription('A natural description of the channel');
            firebase.notifications().android.createChannel(channel);

            return firebase.notifications().onNotification((notification) => {
                if (Platform.OS === 'android') {
                    const localNotification = new firebase.notifications.Notification({
                        sound: 'default',
                        show_in_foreground: true,
                    }).setNotificationId(notification.notificationId)
                        .setTitle(notification.title)
                        .setSubtitle(notification.subtitle)
                        .setBody(notification.body)
                        .setData(notification.data)
                        .android.setChannelId('channelId') // e.g. the id you chose above
                        .android.setSmallIcon('logo') // create this icon in Android Studio
                        .android.setColor('#000000') // you can set a color here
                        .android.setPriority(firebase.notifications.Android.Priority.High);

                    firebase.notifications()
                        .displayNotification(localNotification)
                        .catch(err => console.error(err));

                }
                else if (Platform.OS === 'ios') {

                    const localNotification = new firebase.notifications.Notification()
                        .setNotificationId(notification.notificationId)
                        .setTitle(notification.title)
                        .setSubtitle(notification.subtitle)
                        .setBody(notification.body)
                        .setData(notification.data)
                        .ios.setBadge(notification.ios.badge);

                    firebase.notifications()
                        .displayNotification(localNotification)
                        .catch(err => console.error(err));
                }


                if (notification && typeExport._TypeApp === "Satia") {
                    func ? func() : null
                }

                if (notification && notification.data && notification.data.typeOperation == 2) {
                    func ? func() : null
                }

                else if (notification && notification.data && notification.data.typeOperation === '1') {
                    let item = null

                    if (notification.data.menu) {
                        item = JSON.parse(notification.data.menu.replace(new RegExp('}"', "g"), "}").replace(new RegExp('"{', "g"), "{").trim())

                        if (item.length > 0) {
                            global.list_menu_shahrdar = item;

                            func ? func() : null

                        }
                    }
                }


            });
        }
    }

    static
    async goDetailsOpenNotif(func) {

        if (Platform.OS !== "web" && firebase) {
            const notificationOpen = await
                firebase.notifications().getInitialNotification();
            //console.log("NotificationOpen2", notificationOpen)
            let item = null

            if (notificationOpen) {
                if (notificationOpen.notification.data.item)
                    item = JSON.parse(notificationOpen.notification.data.item.replace(new RegExp('}"', "g"), "}").replace(new RegExp('"{', "g"), "{").trim())
                /*   console.log("notificationOpen2", notificationOpen)
                   console.log("notificationOpen.action2", notificationOpen.action)
                   console.log("notificationOpen.notification2", notificationOpen.notification)*/
                firebase.notifications().removeDeliveredNotification(notificationOpen.notification._notificationId)

                try {
                    switch (notificationOpen.notification.data.typeOperation) {
                        //looking for
                        case "2":
                            if (item)
                                NavigationService.navigateParams("DetailsOperatorFireApplyScreen", {
                                    index: 0,
                                    item: item,
                                })
                            // console.log("notificationOpen1", notificationOpen.notification.data.type)
                            // NavigationService.navigatereset("MessagesBuy", {type: 1});
                            //     NavigationService.navigateParams("MessagesBuy", {type: 2});
                            break;

                        case "1":
                            //  console.log("notificationOpen2", notificationOpen.notification.data.type)
                            // NavigationService.navigatereset("MessagesSell", {type: 2});
                            //NavigationService.navigateParams("MessagesSell", {type: 1});
                            break;
                        default:
                        // console.log("notificationOpen", notificationOpen.notification.data.type)

                    }

                }
                catch (e) {

                }
            }
        }


    }


    static checkPhone(text) {
        const reg = /^0[0-9]{2,}[0-9]{8,}$/;

        text = Tools.persianToEnglish(text)
        //  const reg = /^0\d{2,3}-\d{8}$/;
        return reg.test(text)

    }


    static switchGoScreenSatia(item, ServicesReserve, myService, funcShowModal) {
        switch (parseFloat(item.type)) {

            case 0 :
                // NavigationService.navigateParams("ListOnlineChargingHistorySatiaScreen", {item})

                //NavigationService.navigateParams("IncreaseCreditScreen", {item})


                /*      if (item.id == 71) {
                          NavigationService.navigateParams("RegisterComplaintsScreen", {item})

                      } else*/
                //    Tools.GoLink(item.link_url)
                /*  if (store.getState().reducerSplashSatiaScreen.Connection) {
                      // if (item.id == 123)
                      //     NavigationService.navigateParams("AdvancedSearchScreen", {item})
                      //   // NavigationService.navigateParams("GraveyardScreen", {item})
                      // else

                      if (item.login && !store.getState().reducerSplashSatiaScreen.token) {
                          store.dispatch(serviceActionSetState({
                              type: "WebViewScreen",
                              //   type: "InformationFanoosScreen",
                              item: item
                          }))
                          NavigationService.navigateParams('LoginEnterPhoneScreen')
                      }
                      else {

                          NavigationService.navigateParams("WebViewScreen", {item})
                          //NavigationService.navigateParams("InformationFanoosScreen", {item})

                      }
                  }
                  else {
                      ParentScreen.ShowMessageBack(i18n.t('constant.CheckYourInternet'))
                  }*/
                break;


            case 1 :
                //NavigationService.navigateParams("ListServiceSatiaScreen", {item})

                NavigationService.navigateParams("ListServiceSatiaScreen", {
                    // transition: 'collapseExpand',
                    item,
                    ServicesReserve,
                    myService
                })
                break;


            case 2 :
                // this.setState({
                //     showModal: true
                // })

                funcShowModal ? funcShowModal() : null;
                //      Tools.GoLink(item.link_url)

                break;


            case 3 :
                NavigationService.navigateParams("ListGigSatiaScreen", {
                    //transition: 'collapseExpand',
                    item,
                    myService
                })

                //   NavigationService.navigateParams("ListGigSatiaScreen", {item})

                break;


            case 4 :
                NavigationService.navigateParams("UploadDocumentSatiaScreen", {
                    // transition: 'SlideFromBottom',
                    item
                })

                break;


            case 5 :


                //   NavigationService.navigateParams("ServiceHistorySatiaScreen", {item,})

                NavigationService.navigateParams("ListServiceHistorySatiaScreen", {item,})


                break;


            case 6 :
                NavigationService.navigateParams("ListHistoryTelephoneLineStatusSatiaScreen", {item,})

                break;

            case  7 :
                NavigationService.navigateParams("ListMicroConsumptionSatiaScreen", {
                    item,
                    myService
                })

                break;

            case  8 :
                NavigationService.navigateParams("ListMessageSatiaScreen", {item})
                break;

            case  9 :
                NavigationService.navigateParams("ListMessageOperatorSatiaScreen", {item});
                break;
            case  10 :
                // if (Platform.OS == 'web') {
                //     window.open(item.link_url + `&AppToken=${userSatia && userSatia.customer ? userSatia.customer.AppToken : null}`, '_blank');
                // } else {
                NavigationService.navigateParams("WebViewScreen", {item: JSON.stringify(item)});
                //  }
                break;

            case  11 :
                NavigationService.navigateParams("ListOnlineChargingHistorySatiaScreen", {item})
                break;
            case  12 :
                Tools.GoLink(item.link_url)
                break;
            case  13 :
                if (Platform.OS === "web") {
                    HMAlert(
                        i18n.t('constant.message'),
                        "این قابلیت برای وب قابل دسترس نیست",
                        [
                            // {text: 'Ask me later', onPress: () => {}},
                            // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                            {
                                text: i18n.t('constant.ok'),
                                onPress: () => {
                                    // NavigationService.Pop()

                                }
                            },
                        ],
                        {cancelable: true}
                    )
                }
                else {
                    NavigationService.navigateParams("TestConnectionScreen", {item})
                }
                break;
            case  14 :
                // navigator
                //     .share({
                //         title: "`${postTitle} | ${siteTitle}`,"
                //         text: `Check out ${postTitle} on ${siteTitle}`,
                //         url: document.location.href,
                //     })
                //     .then(() => {
                //     })
                //     .catch(error => {
                //         console.error('Something went wrong sharing the blog', error);
                //     });
                Tools.onShare(item);
                break;


            case  15 :
                NavigationService.navigateParams("ContactUsScreen", {item})
                //  NavigationService.navigateParams("WheelScreen", {item})
                break;

            case  16 :
                NavigationService.navigateParams("ChangeInformationSatiaScreen", {item})
                break;

            case  17 :
                NavigationService.navigateParams("ListVirtualBankSatiaScreen", {item})
                break;
            case  18 :
                NavigationService.navigateParams("HelpSoftwareSatiaScreen", {item})
                break;
            case  19 :
                NavigationService.navigateParams("IntroduceFriendsSatiaScreen", {item})
                break;
            case  "satia2" :
                NavigationService.navigateParams("AdvancedSearchScreen", {item})
                break;
            case  "satia3" :
                NavigationService.navigateParams("AdvancedSearchScreen", {item})
                break;
            case  "satia4" :
                NavigationService.navigateParams("AdvancedSearchScreen", {item})
                break;

            default:
                HMAlert(
                    i18n.t('constant.message'),
                    "لطفا نرم افزار را بروزرسانی نمایید",
                    [
                        {
                            text: i18n.t('constant.ok'),
                            onPress: () => {

                            }


                        },

                    ],
                    {cancelable: true}
                )
        }
    }


    static   getDuration = function (url, next) {
        var _player = new Audio(url);
        _player.addEventListener("durationchange", function (e) {

            if (this.duration != Infinity) {
                var duration = this.duration
                _player.remove();
                next(duration);
            }
            ;
        }, false);
        // _player.load();
        // _player.currentTime = 24*60*60; //fake big time
        // _player.volume = 0;
        // _player.play();
        //waiting...
    }


    /*
            const videoTypes = ["webm", "ogg", "mp4", "x-matroska"];
        const audioTypes = ["webm", "ogg", "mp3", "x-matroska"];
        const codecs = ["vp9", "vp9.0", "vp8", "vp8.0", "avc1", "av1", "h265", "h.265", "h264", "h.264", "opus", "pcm", "aac", "mpeg", "mp4a"];
        //console.log(Tools.getSupportedMimeTypes("audio", audioTypes, codecs))
        const supportedVideos = Tools.getSupportedMimeTypes("video", videoTypes, codecs);
        const supportedAudios = Tools.getSupportedMimeTypes("audio", audioTypes, codecs);

    * */
    static getSupportedMimeTypes(media, types, codecs) {
        const isSupported = MediaRecorder.isTypeSupported;
        const supported = [];
        types.forEach((type) => {
            const mimeType = `${media}/${type}`;
            codecs.forEach((codec) => [
                `${mimeType};codecs=${codec}`,
                `${mimeType};codecs:${codec}`,
                `${mimeType};codecs=${codec.toUpperCase()}`,
                `${mimeType};codecs:${codec.toUpperCase()}`
            ].forEach(variation => {
                if (isSupported(variation))
                    supported.push(variation);
            }));
            if (isSupported(mimeType))
                supported.push(mimeType);
        });
        return supported;
    };

    static   resizeFile = (file) => new Promise(resolve => {
        Resizer.imageFileResizer(file, 1000, 1000, 'JPEG', 100, 0,
            uri => {

                resolve(uri);
            },
            'blob'
        );
    });

    static cloneAsObject(obj) {
        if (obj === null || !(obj instanceof Object)) {
            return obj;
        }
        var temp = (obj instanceof Array) ? [] : {};
        // ReSharper disable once MissingHasOwnPropertyInForeach
        for (var key in obj) {
            temp[key] = Tools.cloneAsObject(obj[key]);
        }
        return temp;
    }


    static async RequestServer(typeConnection, url, formData, type, func) {


        const config = {
            headers: {
                "Content-Type": "multipart/form-data; charset=utf-8;",
                // 'Content-Type': 'application/json',
                //  "Authorization": `Basic ${params.token}`,
                timeout: typeExport._TIMEOUT,
            }
        };

        axios.post(url, formData, config)
            .then(async response => {

                func ? func(response) : null;
            }).catch((e) => {
            func ? func(null) : null;

            console.log(e)
        })
    }

    static convertFormDataToSoap(mode, formData) {


        if (formData) {
            let ResultString = "";
            for (var pair of formData.entries()) {
                let name = pair[0];
                let value = pair[1];
                ResultString += `<${name}>${value}</${name}>`
            }

            let sr =
                '<?xml version="1.0" encoding="utf-8"?>' +
                '<soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">' +
                '<soap:Body>' +
                `<${mode} xmlns="http://tempuri.org/">` +
                ResultString +
                `</${mode}>` +
                '</soap:Body>' +
                '</soap:Envelope>';

            return sr
        }

        else
            return null;
        // let sr =
        //     '<?xml version="1.0" encoding="utf-8"?>' +
        //     '<soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">' +
        //     '<soap:Body>' +
        //     `<GetAddress${typeExport._NameMap} xmlns="http://tempuri.org/">` +
        //     `<name>${this.state.textInputSearch}</name>` +
        //     `</GetAddress${typeExport._NameMap}>` +
        //     '</soap:Body>' +
        //     '</soap:Envelope>';


    }

    static checkInputLessCharacter(text, limit = 2) {
        if (text && text.length > limit) {
            return true;
        }
        else
            return false;

    }

    static consoleFormData(formData) {
        for (var pair of formData.entries()) {
            console.log("formData1", pair);
            console.log(pair[0] + ', ' + pair[1]);
        }

    }


    static getPercentage(count, countAll) {

        if (countAll == 0) {
            return 0;
        }

        let d = (((count / countAll) * 100));
        //return ((d).toFixed(Tools.getToFixed(d)) + "");
        return ((d).toFixed(Tools.getToFixed((d % 1 === 0) ? 0 : d)) + "");


    }

    static getSortList(list, x, y, type) {

        // list.sort(function (a, b) {
        //     if (type == "asc")
        //         return a[x] + b[y]
        //     else
        //         return a[x] - b[y]
        // });
        let res = list.sort(function (a, b) {
            if (type == "desc")
                return a[x] - b[y]
            else
                return b[y] - a[x]
        });
        // console.log("res@@@1", res);

        return res;

    }

    static showAlertUpdateApp() {

        HMAlert(i18n.t('constant.message'), "نرم افزار نیاز به بروزرسانی دارد", [
                // {text: 'Ask me later', onPress: () => {}},
                // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                {
                    text: i18n.t('constant.ok'),
                    onPress: () => {
                        let DataSplashScreen = store.getState().reducerSplashGetAllData.resultsSaina ? store.getState().reducerSplashGetAllData.resultsSaina.result.info : (store.getState().reducerSplashGetAllData.resultsShahrdar ? store.getState().reducerSplashGetAllData.resultsShahrdar.result.info : null)
                        let DataSplasSatiahScreen = store.getState().reducerSplashSatiaScreen.results ? store.getState().reducerSplashSatiaScreen.results.info : null
                        let DataSplash = DataSplashScreen ? DataSplashScreen : (DataSplasSatiahScreen ? DataSplasSatiahScreen : null);
                        if (DataSplash)
                            Tools.GoLink_AI(DataSplash?.ios?.link, DataSplash?.android?.link)
                    }
                },
                {
                    text: 'خیر', onPress: () => {
                    }, style: 'cancel'
                },
            ],
            {cancelable: false}
        )

    }

    static addAllFormData(formData, checkCity, typeRequest) {
        let {Location, City, TypeLogin, OrganCity, user} = store.getState().reducerSplashGetAllData;

        City = (typeRequest === "City") ? City : OrganCity;
        formData.append('tenant_id', City && (checkCity || (user && user.orgs)) ? City.tenant_id : 0);
        // formData.append('platform', Platform.OS);


        const latitude = Platform.OS === "web" ? formData.get('latitude') : formData.getParts().find(item => item.fieldName === 'latitude');
        if (latitude) {
            // const value = latitude.string;
        }
        // if (formData.get('latitude')) {
        // }
        else {

            formData.append('latitude', Location?.coords.latitude);
            formData.append('longitude', Location?.coords.longitude);
        }

    }

    static addAllParams(pararms, checkCity, typeRequest) {
        let {Location, City, OrganCity, TypeLogin, user} = store.getState().reducerSplashGetAllData;
        City = (typeRequest === "City") ? City : OrganCity;
        return Object.assign(pararms, pararms.latitude ? {'tenant_id': City && (checkCity || (user && user.orgs)) ? City.tenant_id : 0,} : {
            // 'tenant_id': City && checkCity ? City.tenant_id : 0,
            'tenant_id': City && (checkCity || (user && user.orgs)) ? City.tenant_id : 0,
            'latitude': Location ? Location.coords.latitude : null,
            'longitude': Location ? Location.coords.longitude : null,
            //  'platform': Platform.OS,

        });
        // formData.append('tenant_id', City?.tenant_id);
        // formData.append('latitude', Location?.coords.latitude);
        // formData.append('longitude', Location?.coords.longitude);
    }

    static copyClipboardWeb(text) {
        if (navigator.clipboard) {

            navigator.clipboard.writeText(text).then(function () {
                console.log('Copied to clipboard successfully!');
                Toast.show({
                    // type: 'success | error | info',
                    type: 'custom_info',
                    //  type: data.status ? 'custom_success' : 'custom_error',
                    //  position: 'top | bottom',
                    position: 'top',
                    text1: i18n.t('constant.message'),
                    text2: "لینک کپی شد" + "\n" + text,
                    visibilityTime: 5000,
                    autoHide: true,
                    //  topOffset: 30,
                    // bottomOffset: 40,
                    onShow: () => {
                    },
                    onHide: () => {
                    }
                })
            }, function () {
                console.error('Unable to write to clipboard. :-(');

                const textArea = document.createElement("textarea");
                textArea.value = text;
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
                try {
                    document.execCommand('copy');
                    Toast.show({
                        // type: 'success | error | info',
                        type: 'custom_info',
                        //  type: data.status ? 'custom_success' : 'custom_error',
                        //  position: 'top | bottom',
                        position: 'top',
                        text1: i18n.t('constant.message'),
                        text2: "لینک کپی شد" + "\n" + text,
                        visibilityTime: 5000,
                        autoHide: true,
                        //  topOffset: 30,
                        // bottomOffset: 40,
                        onShow: () => {
                        },
                        onHide: () => {
                        }
                    })
                } catch (err) {
                    console.error('Unable to copy to clipboard', err);
                }
                document.body.removeChild(textArea);
            });
        }
    }

    static exitApp() {
        HMAlert(
            i18n.t('constant.message'),
            i18n.t('constant.WantToLogOut'),
            [
                // {text: 'Ask me later', onPress: () => {}},
                {
                    text: i18n.t('constant.No'), onPress: () => {
                    }, style: 'cancel'
                },
                {
                    text: i18n.t('constant.Yes'), onPress: () => {
                        //  this.remove()
                        AsyngStorageClass.removeToken();

                        //    NavigationService.resetTo("Drawer")
                        NavigationService.PopToPop()

                        //, NavigationService.resetTo('SplashScreen')
                    }
                },
            ],
            {cancelable: true}
        )

    }
}
